import React, { useEffect } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import ShadowCard from "../../../components/common/ShadowCard";
import FormDatePicker from "../../../components/formFields/FormDateField";
import moment from "moment";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { GSTRATE } from "../../../_contstants/common";
import { getAllActiveUsers } from "../../user/services/user.services";
import { IUser } from "../../user/userModel";
import { IBranch } from "../../branch/branchModel";
import { getAllBranches } from "../../branch/services/branch.services";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const ChangeWatcher: React.FC<ChangeWatcherProps> = ({ formRenderProps }) => {
  useEffect(() => {
    formRenderProps.onChange("filterFromDate", {
      value: moment().startOf("month").toDate(),
    });
    formRenderProps.onChange("filterToDate", {
      value: moment().toDate(),
    });
  }, []);
  return null;
};

const GSTAndTaxSummaryReportForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);
  const UserList = useAppSelector((state) => state.user.UserList);
  const BranchList = useAppSelector((state) => state.branch.BranchList);

  const handleSubmit = (values: any) => {
    const payload: any = {};

    payload.filterFromDate = values?.filterFromDate
      ? moment(values?.filterFromDate).format("YYYY-MM-DD")
      : "0";
    payload.filterToDate = values?.filterToDate
      ? moment(values?.filterToDate).format("YYYY-MM-DD")
      : "0";
    payload.filterGSTRate = values?.filterGSTRate ? values?.filterGSTRate : "0";
    payload.filterUser = values?.filterUser ? values?.filterUser : "0";
    payload.BranchID = values?.BranchID ? values?.BranchID : "0";
    window.open(
      `gstandtaxsummaryreportview/${payload?.filterFromDate}/${payload?.filterToDate}/${payload?.filterGSTRate}/${payload?.filterUser}/${payload?.BranchID}`
    );
  };

  useEffect(() => {
    dispatch(getAllActiveUsers());
    dispatch(getAllBranches());
  }, []);

  return (
    <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ cols: 10, rows: 0 }}
                  cols={[{ width: "40%" }, { width: "30%" }, { width: "30%" }]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      GST & Tax Summary Report
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      name="filterFromDate"
                      label="From Date"
                      format="dd/MM/yyyy"
                      wrapperStyle={{ width: "100%" }}
                      component={FormDatePicker}
                      astrike={true}
                      validator={requiredValidator}
                    />
                    <Field
                      name="filterToDate"
                      label="To Date"
                      format="dd/MM/yyyy"
                      minDate={moment(
                        formRenderProps.valueGetter("filterFromDate")
                      ).toDate()}
                      wrapperStyle={{ width: "100%" }}
                      component={FormDatePicker}
                      astrike={true}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      name="filterGSTRate"
                      label="GST Rate"
                      placeholder="Select GST Rate"
                      wrapperStyle={{ width: "50%" }}
                      component={FormSelectionField}
                      options={GSTRATE?.map((gstrate: any) => ({
                        value: gstrate?.value,
                        label: gstrate?.label,
                      }))}
                    />
                    <Field
                      name="filterUser"
                      label="User"
                      placeholder="Select User"
                      wrapperStyle={{ width: "50%" }}
                      component={FormSelectionField}
                      options={UserList?.map((user: IUser) => ({
                        value: user?.ID,
                        label: `${user?.FirstName} ${user?.LastName}`,
                      }))}
                    />
                    {/* <Field
                      name="filterStatus"
                      label="Status"
                      placeholder="Select Status"
                      wrapperStyle={{ width: "50%" }}
                      component={FormSelectionField}
                      options={GSTTAXSTATUS?.map((status: any) => ({
                        value: status?.value,
                        label: status?.label,
                      }))}
                    /> */}
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      name="BranchID"
                      wrapperClassName="w-100"
                      label="Branch"
                      placeholder="Select Branch"
                      component={FormSelectionField}
                      options={BranchList?.map((branch: IBranch) => ({
                        value: branch?.ID,
                        label: `${branch?.BranchName} - ${branch?.CompanyName}`,
                      }))}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      display: "flex",
                      gap: 10,
                      position: "relative",
                      minHeight: 50,
                    }}
                  >
                    <div style={{ position: "absolute", top: 20, right: 0 }}>
                      <ButtonWithLoading
                        label={"Get Details"}
                        type="submit"
                        Size="medium"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </div>
                  </GridLayoutItem>
                </GridLayout>
                <ChangeWatcher formRenderProps={formRenderProps} />
              </FormElement>
            )}
          />
        </ShadowCard>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default GSTAndTaxSummaryReportForm;
